//Request Constants
export const ALL_REQUEST_STATUS = 'status=created&status=accepted&status=rejected';
export const ACTIVE_REQUEST_STATUS = 'status=created';
export const REJECTED_REQUEST_STATUS = 'status=rejected';

export const ALL_REQUEST = ['accepted', 'created'];
export const ACTIVE_REQUEST = 'created';
export const REJECTED_REQUEST = 'rejected';
export const PAYMENT_REQUEST = 'accepted';
